// React
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
// ライブラリ
import Swal from 'sweetalert2';
// コンポーネント
import UpdateEmail from './UpdateEmail/UpdateEmail';
import UpdatePassword from './UpdatePassword/UpdatePassword';
import SocialInformation from './SocialInformation/SocialInformation';
// ユーティリティ
import { menu } from '../../../constants';
import { errorMessages } from '../../../utils/messagesUtils';

import sty from './Settings.module.css';

const Settings = () => {
    const [email, setEmail] = useState('');
    const [isSocial, setIsSocial] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [apiPath, setApiPath] = useState('');
    const [signinPath, setSigninPath] = useState('');


    // URLに基づいてAPIパスを設定
    useEffect(() => {
        const currentPath = location.pathname;
        if (currentPath.startsWith('/mng')) {
            setApiPath(menu.MNG.SETTINGS.PATH);
            setSigninPath(menu.MNG.SIGNIN.PATH);
            setIsAdmin(true);
        } else {
            setApiPath(menu.ENGINEER.SETTINGS.PATH);
            setSigninPath(menu.ENGINEER.SIGNIN.PATH);
            setIsAdmin(false);
        }
    }, [location.pathname]);

    const fetchData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${apiPath}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                credentials: 'include'
            });
            const result = await response.json();
            if (response.status === 200 && result.status === 'OK') {
                setEmail(result.email);
                if(result.loginType === 'social')
                    setIsSocial(true)
                else
                    setIsSocial(false)
            } else {
                if(response.status === 401){ 
                    navigate(signinPath);
                } else {
                    const error = new Error();
                    error.front_message = errorMessages.common.data_fetch_failed;
                    throw error;
                }
            }
        } catch (e) {
            await Swal.fire({
                icon: 'error',
                html: `${e.front_message || errorMessages.api.server_error}`,
                customClass: {
                    htmlContainer: 'large-text'
                }
            });
        }
    }

    useEffect(() => {
        if(apiPath){
            fetchData();
        }
    }, [apiPath]);

    // タブに関する設定
    const [activeTab, setActiveTab] = useState('tab2');

    const handleTabClick = (tabName) => {
        return setActiveTab(tabName);
    };

    // アクティブなタグかどうか判定
    const isActiveTab = (tabName) => {
        return activeTab === tabName ? sty['active-tab'] : '';
    };
    return (
        <div className="bg">
            <div className="main-container" >
                <div className={sty['form-tabs']}>
                    <div className={sty['form-tabs__tab-items--settings']}>
                        <button onClick={() => handleTabClick('tab1')} className={`${sty['form-tabs__tab-item']} ${isActiveTab('tab1')}`}>
                            <p>MAIL</p>
                            <p>メールアドレス変更</p>
                        </button>
                        <button onClick={() => handleTabClick('tab2')} className={`${sty['form-tabs__tab-item']} ${isActiveTab('tab2')}`}>
                            <p>PASSWORD</p>
                            <p>パスワード変更</p>
                        </button>
                    </div>

                    {/* タブの内容 */}
                    <div className={sty['form-tab__content']}>
                        {(activeTab === 'tab1' || activeTab === 'tab2') && isSocial && <SocialInformation />}
                        {activeTab === 'tab1' && !isSocial && <UpdateEmail email={email} isAdmin={isAdmin}/>}
                        {activeTab === 'tab2' && !isSocial && <UpdatePassword />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Settings;


